import { render } from "./Bodegas.vue?vue&type=template&id=24535710&scoped=true"
import script from "./Bodegas.vue?vue&type=script&lang=js"
export * from "./Bodegas.vue?vue&type=script&lang=js"

import "./Bodegas.vue?vue&type=style&index=0&id=24535710&scoped=true&lang=css"

import exportComponent from "/Users/ward/Projects/Chelsea/sherryV2/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24535710"]])

export default __exports__